var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.removeWidget}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-close-box")]),_vm._v(" Remove "+_vm._s(_vm.widgetName))],1)}
var staticRenderFns = []

export { render, staticRenderFns }